import { Box, Tooltip } from '@mui/material'

const levels = 4

function getColor(value) {
  if (value <= 0) return 'var(--text-secondary, #6b7280)'
  if (value < 25) return '#ff3d57'
  if (value < 50) return '#ffa65c'
  if (value < 75) return '#f7b84b'
  return '#1fd8a8'
}

function SignalBars({ value = 0, max = 100, size = 8, gap = 2, showLabel = false, sx, ...rest }) {
  const safeValue = Math.max(0, Math.min(value, max))
  const percent = max > 0 ? (safeValue / max) * 100 : 0
  const activeBars = Math.ceil((percent / 100) * levels)
  const color = getColor(percent)

  const bars = Array.from({ length: levels }, (_, i) => {
    const barHeight = size + i * (size * 0.6)
    const isActive = i < activeBars
    return (
      <Box
        key={i}
        sx={{
          width: size * 0.7,
          height: barHeight,
          borderRadius: '2px',
          backgroundColor: isActive ? color : 'var(--chip-filled-bg, rgba(0,0,0,0.08))',
          transition: 'background-color 0.2s ease',
        }}
      />
    )
  })

  const content = (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'flex-end',
        gap: `${gap}px`,
        lineHeight: 1,
        ...sx,
      }}
      {...rest}
    >
      {bars}
      {showLabel && (
        <Box
          component="span"
          sx={{
            ml: 0.75,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: color,
          }}
        >
          {Math.round(percent)}%
        </Box>
      )}
    </Box>
  )

  return (
    <Tooltip title={`${Math.round(percent)}%`} arrow placement="top">
      {content}
    </Tooltip>
  )
}

export { SignalBars }
export default SignalBars
